module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/banner_hiramatsu-cbd95f6a92fd0bcd7aa256031541590e.webp";